import * as FlatModels from '@medsurf/flat-models';

// <editor-fold desc="Action Types">

/**
 * Action types
 */
export enum ActionTypes {
  /**
   * Store
   */
  GetTextExports = '[STORE | AUTHOR | TEXT-EXPORT] Get Text Exports',
  GetTextExportsSuccess = '[STORE | AUTHOR | TEXT-EXPORT] Get Text Exports Success',
  /**
   * Request
   */
  GetTextExportRequest = '[REQUEST | API | TEXT-EXPORT] Get Text Export Request'
}

// </editor-fold>

// <editor-fold desc="Models">

// </editor-fold>

// <editor-fold desc="Store">

/**
 * Get Text Exports
 */
export class GetTextExports {
  public static readonly type = ActionTypes.GetTextExports;

  public constructor(public id: string) {
  }
}

/**
 * Get Text Exports Success
 */
export class GetTextExportsSuccess {
  public static readonly type = ActionTypes.GetTextExportsSuccess;

  public constructor(public entityQueryResults: FlatModels.TextExportAuthorModels.TextExportResult[]) {
  }
}

// </editor-fold>

// <editor-fold desc="Request">

/**
 * Get Text Export Request
 */
export class GetTextExportRequest {
  public static readonly type = ActionTypes.GetTextExportRequest;

  public constructor(public id: string) {
  }
}

// </editor-fold>
